export const CONFIG_PAGE_TYPE_PLP = 'plp';
export const URGENCY_NUDGE_REMOTE_CONFIG = 'urgencyNudge';
export const BEST_PRICE_EXP = 'bestprice-plp';
